import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryTextTypography, StyledSecondaryIcon } from '../../../../../App.styles';
import { Icons } from '../../../../../stories/atoms';
import { ColumnFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { storeOverviewTranslations } from '../../../../../translations';

export const NoDataForPeriodView: FC<unknown> = () => {
  const { t } = useTranslation();
  return (
    <ColumnFlexContainer
      flex={1}
      height="100%"
      data-testid="no-data-for-period-view"
      justifyContent="center"
      alignItems="center"
      gap={[1]}
    >
      <StyledSecondaryIcon icon={Icons.SEARCH} size="large" />
      <SecondaryTextTypography type="h4">
        {t(
          storeOverviewTranslations.noDataFilterText.key,
          storeOverviewTranslations.noDataFilterText.defaultValue,
        )}
      </SecondaryTextTypography>
      <SecondaryTextTypography textAlign="center">
        {t(
          storeOverviewTranslations.changeFilterText.key,
          storeOverviewTranslations.changeFilterText.defaultValue,
        )}
      </SecondaryTextTypography>
    </ColumnFlexContainer>
  );
};
